import { useCallback } from 'react';
import { DataTable } from '@london-life/ui/admin/data-table';
import { PageHeader } from '@london-life/ui/admin/page-header';
import { ErrorNotice } from '@london-life/ui/feedback/error-notice';
import { api } from '../lib/api';
import { useRequest } from '../lib/use-request';
import { when } from '../lib/format';

// the append-only record of every admin action and sign-in, newest first
export function AuditPage() {
  const audit = useRequest(useCallback(() => api.admin.audit({ limit: 100 }), []));
  return (
    <section>
      <PageHeader
        title="Audit log"
        description="Every admin change and sign-in, newest first. Entries can never be edited."
      />
      {audit.error && <ErrorNotice error={audit.error} onRetry={() => void audit.reload()} />}
      <DataTable
        rows={audit.data?.entries ?? null}
        loading={audit.busy}
        rowKey={(entry) => entry.id}
        empty="No activity recorded yet."
        columns={[
          { key: 'when', header: 'When', render: (entry) => when(entry.createdAt) },
          { key: 'action', header: 'Action', render: (entry) => <strong>{entry.action}</strong> },
          { key: 'subject', header: 'Subject', render: (entry) => `${entry.subjectType} ${entry.subjectId ?? ''}` },
          {
            key: 'actor',
            header: 'By',
            render: (entry) => <span className="admin-muted">{entry.actorUserId ?? 'system'}</span>,
          },
          {
            key: 'change',
            header: 'Change',
            render: (entry) => (
              <code className="admin-code">{JSON.stringify({ before: entry.before, after: entry.after })}</code>
            ),
          },
        ]}
      />
    </section>
  );
}
